import React, { useCallback, useEffect, useState } from "react";
import Lottie from "lottie-react";
import useNavigation from "../hooks/useNavigation";
import "./footerButton.css";
import CustomLottie from "../components/custom-lottie"; // Importa un file CSS separato per definire la posizione e lo stile del componente

type FooterButtonProps = {
  canBeClicked?: boolean;
  introAnimationData: any;
  loopAnimationData: any;
  glowAnimationData: any;
  buttonType: "home" | "info" | "exit" | "hidden";
  onClick: () => void; // Add onClick prop
  className?: string;
  style?: React.CSSProperties;
};

const FooterButton: React.FC<FooterButtonProps> = ({
  canBeClicked = false,
  introAnimationData,
  loopAnimationData,
  glowAnimationData,
  buttonType,
  onClick, // Add onClick prop
  className,
    style
}) => {
  const [hideIntro, setHideIntro] = useState<boolean>(false);
  const [isHiddenButton, setIsHiddenButton] = useState<boolean>(false);
  const [showGlowAnimation, setShowGlowAnimation] = useState<boolean>(false);

  const onIntroAnimationComplete = useCallback(() => {
    setHideIntro(true);
  }, []);

  const handleButtonClick = () => {
    if (canBeClicked) {
      setShowGlowAnimation(true);

      setTimeout(() => {
        setShowGlowAnimation(false);
        //TODO: se e' home, fai sparire tutta la pagina prima

      }, 250);
      onClick(); // Trigger the provided onClick function
    }
  };

  // Add a useEffect to handle hidden button parameter
  useEffect(() => {
    if (buttonType === "hidden") {
      setIsHiddenButton(true);
    }
  }, [buttonType, setIsHiddenButton]);

    useEffect(() => {
        document.getElementsByName('')
    }, []);

  return (
    <div className={className} style={style}>
      <div
        className="footer-button-container relative" // Usa una classe CSS per definire la posizione e lo stile del componente
        onMouseEnter={() => {
          if (hideIntro) {
            setShowGlowAnimation(true);
          }
        }}
        onMouseLeave={() => {
          if (hideIntro) {
            setShowGlowAnimation(false);
          }
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!isHiddenButton && (
          <>
            {!hideIntro && (
              <CustomLottie
                animationData={introAnimationData}
                autoplay={true}
                loop={false}
                className="lottie-animation"
                onComplete={onIntroAnimationComplete}
                style={{ maxWidth: "50%" }}
                speed={0.8}
              />
            )}
            {hideIntro && (
              <CustomLottie
                animationData={loopAnimationData}
                autoplay={true}
                loop={true}
                className={`lottie-animation${
                  canBeClicked ? " cursor-pointer" : ""
                } `}
                onClick={handleButtonClick}
                style={{ maxWidth: "50%" }}
                speed={0.8}
              />
            )}

            {showGlowAnimation && (
              <>
                <CustomLottie
                  animationData={glowAnimationData}
                  autoplay={true}
                  loop={false}
                  className="lottie-animation glow-animation absolute top-0"
                  style={{ maxWidth: "50%" }}
                  speed={0.8}
                />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default FooterButton;
